// material-ui
import {styled, useTheme} from '@mui/material/styles';
import {Card, CardContent, Grid, Typography} from '@mui/material';
import {format} from "date-fns";
import React from "react";

// project imports

// styles
const CardStyle = styled(Card)(({theme}) => ({
    background: theme.palette.mode === 'dark' ? theme.palette.dark[800] : theme.palette.primary.light,
    marginTop: '16px',
    marginBottom: '16px',
    overflow: 'hidden',
    position: 'relative',
    '&:after': {
        content: '""',
        position: 'absolute',
        width: '200px',
        height: '200px',
        border: '19px solid ',
        borderColor: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.main,
        borderRadius: '50%',
        top: '65px',
        right: '-150px'
    },
    '&:before': {
        content: '""',
        position: 'absolute',
        width: '200px',
        height: '200px',
        border: '3px solid ',
        borderColor: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.main,
        borderRadius: '50%',
        top: '145px',
        right: '-70px'
    }
}));

// ==============================|| PROFILE MENU - UPGRADE PLAN CARD ||============================== //

const ConsolidateCard = ({lastConsolidate, companiesArray}: { lastConsolidate: any[], companiesArray: any[] }) => {
    const theme = useTheme();

    const lastConsolidateArray = () => {
        let content = (
            <>
                {
                    lastConsolidate.map((el) => {
                        let companyRecord = companiesArray.find((sn) => sn.id == el.location_id)
                        return <>{companyRecord?.name}: {format(new Date(el.last_closure), 'dd/MM/yyyy HH:mm')}<br/>
                        </>
                    })
                }
            </>
        );
        return content
    }

    return (
        <CardStyle>
            <CardContent>
                <Grid container direction="column" spacing={2}>
                    <Grid item>
                        <Typography variant="h4">Ultimi consolidamenti</Typography>
                    </Grid>
                    <Grid item>
                        <Typography
                            variant="subtitle2"
                            color={theme.palette.mode === 'dark' ? 'textSecondary' : 'grey.900'}
                            sx={{opacity: theme.palette.mode === 'dark' ? 1 : 0.6}}
                        >
                            {lastConsolidateArray()}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </CardStyle>
    );
};

export default ConsolidateCard;